import { h } from 'preact'
import { NavLinks } from '../../shared/NavLinks/NavLinks'
import { Parti } from '../../../domain'
import { Message } from '../../../../lib/intl/Message'

type Props = { partier: Parti[] }

export function Nabopartier(props: Props) {
  return (
    <section>
      <h3>
        <Message id="nabopartier-tittel" />
      </h3>
      <NavLinks
        grunndata={props.partier.filter(
          parti => parti.id !== 'BLANKE' && [1, 2, 3].includes(parti.kategori)
        )}
        sorter={true}
        type={'parti'}
      />
    </section>
  )
}
